export default __webpack_public_path__ + "static/media/finishing_touch.59038eaa.svg";